export const urls ={
    apiBaseUrl: "https://anax.api.srashtasoft.in/api/"
}

